// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3YoHoF3D{margin-bottom:2em}.hApAFsXn{margin-bottom:.5em}.jI3lD8Wl{color:#000;font-size:1rem;line-height:1.39}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hint": "_3YoHoF3D",
	"hintCheckbox": "hApAFsXn",
	"hintText": "jI3lD8Wl"
};
module.exports = ___CSS_LOADER_EXPORT___;
